"use client"

import { useEffect } from "react"
import {
  StandaloneButton,
  StandaloneCard,
} from "@/components/kumo/standalone-card"
import { captureException, hasDatadogBrowserConfig, initDatadogBrowser } from "@/infrastructure/datadog-browser"

// The root layout is not rendered here, so this boundary loads Kumo itself.
import "./kumo.css"

/**
 * Root-layout error boundary. Must render its own <html>/<body>. Captures to
 * Datadog when configured.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    if (!hasDatadogBrowserConfig()) return
    initDatadogBrowser()
    captureException(error)
  }, [error])

  return (
    <html lang="en" data-mode="light">
      <body>
        <StandaloneCard label="Error" title="Something went wrong">
          <p className="text-kumo-subtle">
            Ortelian hit an unexpected error. Try again, or reload the page.
          </p>
          <StandaloneButton onClick={reset}>Try again</StandaloneButton>
        </StandaloneCard>
      </body>
    </html>
  )
}
